import { FieldArrayWithId, UseFieldArrayReturn } from 'react-hook-form';

import { SortableContainer } from '../../../../../../common/ui/draggable-container';
import { TPageForm } from '../../../../page-form/page-form';
import { AssetsContainer } from '../../../assets-container';
import { PageBanner } from '../page-banner';
import { PageBannerCreator } from '../page-banner-creator';
import styles from './page-banners-form.module.scss';

interface Props {
  methods?: UseFieldArrayReturn<TPageForm, 'pageBanners'>;
}

const PageBannersForm = ({ methods: { append, fields, remove, swap, update } }: Props) => {
  const onDeleteButton = (assetIdx: number, asset: FieldArrayWithId<TPageForm, 'pageBanners'>) => {
    if (asset.type === 'deleted') return;

    if (asset.type === 'new') {
      remove(assetIdx);
    } else {
      update(assetIdx, { ...asset, type: 'deleted' });
    }
  };

  return (
    <div className={styles.form}>
      <AssetsContainer basedVisibleCount={4} className={styles.items_container}>
        <div className={styles.item_wrapper}>
          <PageBannerCreator onChange={(data) => append(data)} />
        </div>
        {fields.map((asset, assetIdx) => {
          if (asset.type === 'deleted') return null;

          return (
            <SortableContainer.ItemWrapper
              key={asset.id}
              className={styles.item_wrapper}
              id={asset.id}
              index={assetIdx}
              moveItem={(from, to) => swap(from, to)}
            >
              <PageBanner
                assetIdx={assetIdx}
                item={asset}
                onDeleteButton={() => onDeleteButton(assetIdx, asset)}
              />
            </SortableContainer.ItemWrapper>
          );
        })}
      </AssetsContainer>
    </div>
  );
};

export { PageBannersForm };
